// extracted by mini-css-extract-plugin
export default {"questions-list-header":"uvEeY","divider":"eTYLc","gap":"_Vrj_"};